import axios from 'axios';
import { getBearerGrantTypeAuthHeaders } from 'helpers/auth_helpers';
import client from './rest/AdminClient';
export const updateContainerDetails = async (containerId, masterBol) => {
    console.log('Master BOL ', masterBol);
    const response = await client({
        method: 'PUT',
        path: `/opentrack/events/refresh/containers/${containerId}?masterBol=${masterBol}`,
    });
    return response ? response.entity : null;
};
export const retrieveContainerStatus = async (containers, masterBol = '') => {
    let requestPath = `/opentrack/events/containers?ids=${encodeURIComponent(containers)}`;
    if (masterBol && masterBol.length) {
        requestPath = `${requestPath}&masterBol=${masterBol}`;
    }
    const response = await client({
        method: 'GET',
        path: requestPath,
    });
    return response ? response.entity : null;
};
export const retrieveRailsightShipperStatus = async (shipper) => {
    var _a;
    const response = await client({
        method: 'GET',
        path: `/admin/railsight/v1/enabled?shipper=` + shipper,
    });
    return ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.enabled) || false;
};
export const getUniqueStatusList = async () => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${API_HOST}/api/opentrack/status-list`,
            headers: {
                Authorization: getBearerGrantTypeAuthHeaders(),
            },
        });
        return response.data.statuses;
    }
    catch (e) {
        return [];
    }
};
